import React, {useCallback, useEffect} from "react";
import {IAzureAudience} from "@fluidframework/azure-client";
import {selectActiveMeeting, setAudienceMembers} from "../meetingSlice";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {meetingApiClient} from "../MeetingApiClient";
import {useRelayContext} from "./types/RelayContext";


type RelayAudienceManagerProps = {
    audience: IAzureAudience | undefined,
}
export const RelayAudienceManager: React.FC<RelayAudienceManagerProps> = ({ audience }) => {
    const dispatch = useAppDispatch();
    const {onlineMeetingId, profileIdToPresent} = useAppSelector(selectActiveMeeting)!;
    const {sharedObjects} = useRelayContext();

    const updateParticipants = useCallback(() => {
        if (!audience) return;
        let localUserId: string | undefined;
        try {
            localUserId = audience.getMyself()?.id;
        } catch (error) {
            console.error("RelayAudienceManager: Failed to get local user from audience.getMyself()", error);
            return;
        }

        meetingApiClient.getMeetingParticipants(profileIdToPresent, onlineMeetingId).then((allowedParticipants) => {
            const audienceMembers = audience.getMembers();
            const activeMeetingParticipants = allowedParticipants
                .filter((meetingParticipant) => audienceMembers.has(meetingParticipant.userId))
                .filter((meetingParticipant) =>
                    meetingParticipant.userId === localUserId||
                     !meetingParticipant.communicationsId
                )
                .sort((a, b) => {
                    if (a.userId === localUserId) return -1;
                    if (b.userId === localUserId) return 1;
                    return 0;
                });
            dispatch(setAudienceMembers(activeMeetingParticipants));
            if (sharedObjects?.meetingParticipantDDS) {
                sharedObjects.meetingParticipantDDS.set('participants', activeMeetingParticipants);
            }
        });
    }, [audience, sharedObjects, profileIdToPresent, onlineMeetingId, dispatch]);

    useEffect(() => {
        if (!audience) return;
        updateParticipants();
        const handleUpdateParticipants = () => updateParticipants();
        audience.on('membersChanged', handleUpdateParticipants);
        return () => {
            audience.off('membersChanged', handleUpdateParticipants);
        }
    }, [updateParticipants, audience]);

    return null;
}
